  class InfiniteScroll {
    constructor() {
      this.productGrid = document.getElementById('product-grid');
      if (!this.productGrid) return;

      const data = window.infiniteScrollData;
      if (!data) {
        console.warn('InfiniteScroll: window.infiniteScrollData not found');
        return;
      }

      this.totalPages = data.totalPages;
      this.currentPage = data.currentPage;
      this.loading = false;
      this.done = false;
      this.baseUrl = window.location.pathname;
      this.searchParams = new URLSearchParams(window.location.search);

      console.log(`InfiniteScroll ready: page ${this.currentPage} of ${this.totalPages}`);

      if (this.totalPages <= 1) {
        console.log('InfiniteScroll: Only 1 page, nothing to do');
        return;
      }

      this.init();
    }

    init() {
      const pagination = document.querySelector('.pagination-wrapper');
      if (pagination) pagination.style.display = 'none';


      this.spinner = document.createElement('div');
      this.spinner.className = 'infinite-scroll-spinner';
      this.spinner.innerHTML = `
        <div class="infinite-scroll-spinner__text">Loading</div>
          <div class="infinite-scroll-spinner__dots">
              <div class="infinite-scroll-spinner__dot"></div>
              <div class="infinite-scroll-spinner__dot"></div>
              <div class="infinite-scroll-spinner__dot"></div>
          </div>
      `;
      this.spinner.style.display = 'none';
      this.productGrid.parentElement.appendChild(this.spinner);


      this.sentinel = document.createElement('div');
      this.sentinel.className = 'infinite-scroll-sentinel';
      this.sentinel.style.height = '10px';
      this.productGrid.parentElement.appendChild(this.sentinel);

      this.setupObserver();
    }

    getNextPageUrl() {
      const params = new URLSearchParams(this.searchParams.toString());
      params.set('page', this.currentPage + 1);
      return `${this.baseUrl}?${params.toString()}`;
    }

    setupObserver() {
      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting && !this.loading && !this.done) {
              this.loadNextPage();
            }
          });
        },
        { rootMargin: '800px' }
      );

      this.observer.observe(this.sentinel);

      this._scrollHandler = () => {
        if (this.loading || this.done) return;
        const scrollBottom = window.scrollY + window.innerHeight;
        const pageBottom = document.body.scrollHeight - 300;
        if (scrollBottom >= pageBottom) {
          this.loadNextPage();
        }
      };

      window.addEventListener('scroll', this._scrollHandler, { passive: true });
      console.log('Observer + scroll fallback attached');
    }

    stopListeners() {
      this.done = true;
      this.observer.disconnect();
      window.removeEventListener('scroll', this._scrollHandler);
    }

    async loadNextPage() {
      if (this.currentPage >= this.totalPages) {
        this.stopListeners();
        console.log('All pages loaded');
        return;
      }

      this.loading = true;
      this.spinner.style.display = 'flex';
      const nextUrl = this.getNextPageUrl();
      console.log('Fetching:', nextUrl);

      try {
        const response = await fetch(nextUrl);
        if (!response.ok) throw new Error(`HTTP ${response.status}`);

        const html = await response.text();
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const newProducts = doc.querySelectorAll('#product-grid .grid__item');

        console.log(`Got ${newProducts.length} new products`);

        if (newProducts.length === 0) {
          this.stopListeners();
          return;
        }

        newProducts.forEach(item => {
          this.productGrid.appendChild(item);
        });

        this.currentPage += 1;
        console.log(`Now on page ${this.currentPage} of ${this.totalPages}`);

        if (this.currentPage >= this.totalPages) {
          this.stopListeners();
          console.log('All pages loaded');
        }

      } catch (error) {
        console.error('InfiniteScroll fetch error:', error);
      } finally {
        this.loading = false;
        this.spinner.style.display = 'none';
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => new InfiniteScroll());
  } else {
    new InfiniteScroll();
  }